import React, { useEffect, useState } from "react";
import styled from "styled-components";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Rating from "@mui/material/Rating";
import { Alert } from "@mui/material";
import ModalConfirm from "../ui/ModalConfirm";
import moment from "moment/moment";
import PlayCircleFilledRoundedIcon from "@mui/icons-material/PlayCircleFilledRounded";
import {
  getReviewDetail,
  updateReplyReview,
  updateStatusReview,
} from "src/api/review";
import Loading from "../ui/Loading";

const WrapperAlert = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 3000;
  animation: showAlert 0.5s;
  margin-top: 15px;
  display: flex;
  justify-content: center;
  top: 0;
  left: 0;
  @keyframes showAlert {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const DivAlert = styled.div`
  min-width: 320px;
  width: fit-content;
  .MuiPaper-root-MuiAlert-root {
    border-radius: 16px;
  }
`;

const Modal = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
const WrapperModal = styled.div`
  max-width: 950px;
  // width: 100%;
  width: -webkit-fill-available;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow:
    0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14),
    0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  // width: fit-content;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  padding: 30px 25px;
  min-width: 800px;
  animation: showModal 0.5s;
  @keyframes showModal {
    0% {
      transform: translate(-50%, -60%);
    }
    100% {
      transform: translate(-50%, -50%);
    }
  }
`;

const WrapperModalInside = styled.div`
  width: 100%;
  height: auto;
  overflow-y: scroll;
  overflow-x: hidden;
  /* margin-top: 16px; */
  margin-bottom: 16px;
  /* margin-left: 16px; */
  /* margin-right: 16px; */
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }

  .Button-New-Brand {
    color: #ffffff;
    width: 98%;
    margin: 8px;
    display: flex;
    justify-content: center;
    background: #e04132;
    box-shadow:
      0px 3px 1px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 16px;
    height: 52px;
    padding: 0 16px;
  }
  .Button-New-Brand:focus {
    background-color: #e04132;
  }
  .Button-New-Brand:hover {
    background-color: #e04132;
    opacity: 0.9;
  }
`;

const WrapperClose = styled.div`
  justify-content: flex-end;
  width: 10%;
  position: absolute;
  display: flex;
  top: 12px;
  right: 12px;
`;

const WrapperTextField = styled.div`
  // margin-bottom: 16px;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  width: 100%;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
    text-align: left;
    // text-align: center;
    // background: #fff;
  }
  .MuiOutlinedInput-input {
    background: #fff;
    text-align: left;
  }
  .MuiInputBase-root-MuiOutlinedInput-root {
    border-radius: 16px;
    background: #fff;
  }
  .MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
    border-radius: 16px;
  }
`;

const DivReview = styled.div`
  border-radius: 16px;
  border: 1px solid #d9d9d9;
  background: #f3f1f2;
  height: 80px;
  max-height: 80px;
  flex-shrink: 0;
  padding: 8px 16px;
  overflow: scroll;
  width: 100%;
  margin: 0px;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;
const SpanCustomerReview = styled.span`
  color: #6c6c70;
  font-size: 0.875rem;
`;

const WrapperFull = styled.div`
  max-width: 800px;
  max-height: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  margin: auto;
  /* opacity: 0.8; */
  position: relative;
`;

const WrapperImageFull = styled.div`
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1200;
  animation: show 0.5s;
  @keyframes show {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

const DivImageReview = styled.div`
  justify-content: flex-start;
  display: flex;
  width: 100%;
  margin: 16px 0;
  overflow-x: scroll;
  overflow-y: hidden;
  ::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #b9b9b9;
    border-radius: 100px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
  }
  ::-webkit-scrollbar-corner {
    background: transparent;
  }
  &:focus {
    outline: none;
  }
`;

const DivHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 16px;
`;
const ImgProduct = styled.img`
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  border-radius: 16px;
  object-fit: cover;
`;

const ImageFull = styled.img`
  width: 80%;
  height: 100%;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
`;

const DivVideo = styled.div`
  width: 128px;
  height: 128px;
  border-radius: 12px;
  margin-right: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  justify-content: center;
  display: flex;
  align-items: center;
  color: black;
  background: #f3f1f2;
`;

const ImgReview = styled.img`
  width: 128px;
  height: 128px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 12px;
  margin-right: 12px;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: pointer;
`;

const ImgSeller = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 4px;
`;
const SpanCustomerName = styled.span`
  color: #252525;
  font-size: 1rem;
  font-weight: 500;
`;
const SpanReview = styled.span`
  color: #6c6c70;
  font-size: 0.75rem;
  margin-right: 8px;
`;
const SpanReviewDate = styled.span`
  color: #252525;
  font-size: 0.875rem;
`;

const WrapperHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
`;
const SpanProductName = styled.span`
  color: #252525;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 4px;
`;

const SpanOption = styled.span`
  color: #252525;
  margin-bottom: 8px;
  font-size: 0.75rem;
`;

const SpanSize = styled.span`
  color: #252525;
  margin-bottom: 0px;
  font-size: 0.75rem;
`;

const SpanSeller = styled.span`
  color: #252525;
  font-size: 0.875rem;
  font-weight: 600;
  margin-left: 8px;
`;

const SpanReviewText = styled.span`
  color: #e6b558;
  text-align: right;
  font-size: 0.875rem;
  margin-left: auto;
`;

const WarpperRating = styled.div`
  & > span > span > span {
    font-size: 1.5rem;
  }
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  color: #252525;
  font-size: 24px;
  font-weight: 500;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: flex-start;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;
function ModalReviewDetail({ visible, onSave, close, title, id }) {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleConfirmApprove, setIsVisibleConfirmApprove] = useState(false);
  const [isVisibleConfirmReply, setIsVisibleConfirmReply] = useState(false);
  const [isVisibleConfirmCancel, setIsVisibleConfirmCancel] = useState(false);
  const [isVisibleAlert, setIsVisibleAlert] = useState(false);
  const [titleAlert, setTitleAlert] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const [isShowFullImage, setIsShowFullImage] = useState(false);
  const [imgShow, setImgShow] = useState("");
  const [textReply, setTextReply] = useState("");
  const [dataReviewDetail, setDataReviewDetail] = useState({
    rating: {
      total: 0,
      quality: 0,
      install: 0,
      service: 0,
      deliver: 0,
    },
    _id: null,
    sellerId: null,
    userId: null,
    pcId: null,
    name: null,
    suggestId: null,
    comment: null,
    status: null,
    isFake: true,
    isHidden: true,
    reply: {
      reply_text: null,
      reply_date: new Date(),
      reply_by: null,
    },
  });
  const closeModal = () => {
    if (titleAlert.length > 0) {
      close(false, true);
    } else {
      close(false);
    }
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { data } = await getReviewDetail(id);
      setDataReviewDetail(data);
      setIsLoading(false);
    })();
  }, [id]);

  const onReply = () => {
    if (id === null) return;
    setIsLoading(true);
    updateReplyReview({
      _id: dataReviewDetail._id,
      reply: {
        reply_date: new Date(),
        reply_text: dataReviewDetail.reply.reply_text,
      },
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getReviewDetail(id);
          setDataReviewDetail(data);
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirmReply(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirmReply(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };
  const conditions = [".mp4", ".mov", ".m4v", ".3gp"];

  const onApprove = () => {
    if (id === null) return;
    setIsLoading(true);
    updateStatusReview({
      _id: dataReviewDetail._id,
      status: "approve",
    })
      .then((res) => {
        setIsLoading(true);
        (async () => {
          const { data } = await getReviewDetail(id);
          setDataReviewDetail(data);
          setIsLoading(false);
          setTitleAlert("Update Success");
          setIsVisibleAlert(true);
          setTypeAlert("success");
          setIsVisibleConfirmApprove(false);
          setTimeout(() => {
            setIsLoading(false);
            setIsVisibleAlert(false);
          }, 1500);
        })();
      })
      .catch((err) => {
        setIsLoading(false);
        setTitleAlert(err.message);
        setIsVisibleAlert(true);
        setTypeAlert("error");
        setIsVisibleConfirmApprove(false);
        setTimeout(() => {
          setIsVisibleAlert(false);
        }, 1500);
      });
  };

  return (
    <Modal>
      <WrapperModal>
        <WrapperClose>
          <HighlightOffRoundedIcon
            sx={{ cursor: "pointer" }}
            onClick={() => {
              if (titleAlert.length > 0 || textReply.length > 0) {
                setIsVisibleConfirmCancel(true); //showmodal alert cancel
              } else {
                closeModal();
              }
            }}
          />
        </WrapperClose>
        <WrapperModalInside>
          <WrapperHeader>
            <WrapperText>รายละเอียดการรีวิวสินค้า</WrapperText>
          </WrapperHeader>

          <DivHeader>
            <div style={{ display: "flex", alignItems: "center" }}>
              <ImgSeller src={dataReviewDetail?.sellerId?.profile_image} />
              <SpanSeller>
                {dataReviewDetail?.sellerId?.company_name}
              </SpanSeller>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <SpanReview>รีวิวเมื่อ :</SpanReview>
              <SpanReviewDate>
                {dataReviewDetail?.createdAt
                  ? moment(dataReviewDetail?.createdAt).format("DD-MM-YYYY")
                  : "-"}
              </SpanReviewDate>
            </div>
          </DivHeader>

          <DivHeader>
            <SpanCustomerName>
              ชื่อลูกค้า {dataReviewDetail?.name}
            </SpanCustomerName>
          </DivHeader>
          <DivHeader>
            <div style={{ display: "flex", alignItems: "center" }}>
              <ImgProduct
                src={
                  dataReviewDetail?.pcId?.group_image?.product_display_image
                    ? dataReviewDetail?.pcId?.group_image?.product_display_image.replace(
                        ".com",
                        ".com/300x300",
                      )
                    : ""
                }
              />
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexDirection: "column",
                  margin: "auto 8px",
                }}
              >
                <SpanProductName>
                  {dataReviewDetail?.pcId?.product?.item_name}
                </SpanProductName>
                <SpanOption>
                  {dataReviewDetail?.pcId?.product?.item_code}
                </SpanOption>
                <SpanOption>
                  {dataReviewDetail?.pcId?.color?.color_th} /{" "}
                  {dataReviewDetail?.pcId?.texture_type?.type_th}
                </SpanOption>
                <SpanSize>
                  {dataReviewDetail?.pcId?.size?.quantity === "size"
                    ? `${`W `}${dataReviewDetail?.pcId?.size?.width} ${
                        dataReviewDetail?.pcId?.size?.unit_width.unit_en
                      } x ${`H `}${dataReviewDetail?.pcId?.size?.height} ${
                        dataReviewDetail?.pcId?.size?.unit_height.unit_en
                      } x ${`D `}${dataReviewDetail?.pcId?.size?.thickness} ${
                        dataReviewDetail?.pcId?.size?.unit_thickness.unit_en
                      }`
                    : `${dataReviewDetail?.pcId?.size?.capacity_size} ${dataReviewDetail?.pcId?.size?.unit_capacity?.unit_en}`}
                </SpanSize>
              </div>
            </div>
            <WarpperRating
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                marginBottom: "auto",
              }}
            >
              <Rating
                name="read-only"
                size="large"
                value={dataReviewDetail?.rating.total}
                readOnly
                sx={{
                  fontSize: "4rem",
                  color: "#E6B558",
                  marginLeft: "auto",
                }}
              />
              <SpanReviewText>
                {dataReviewDetail?.suggestId?.commentTh}
              </SpanReviewText>
            </WarpperRating>
          </DivHeader>
          <DivImageReview>
            {dataReviewDetail?.groupImage?.reviewImage1 && (
              <ImgReview
                src={dataReviewDetail?.groupImage?.reviewImage1}
                onClick={() => {
                  setImgShow(dataReviewDetail?.groupImage?.reviewImage1);
                  setIsShowFullImage(true); //showmodal alert cancel
                }}
              />
            )}
            {dataReviewDetail?.groupImage?.reviewImage2 && (
              <ImgReview
                src={dataReviewDetail?.groupImage?.reviewImage2}
                onClick={() => {
                  setImgShow(dataReviewDetail?.groupImage?.reviewImage2);
                  setIsShowFullImage(true); //showmodal alert cancel
                }}
              />
            )}
            {dataReviewDetail?.groupImage?.reviewImage3 && (
              <ImgReview
                src={dataReviewDetail?.groupImage?.reviewImage3}
                onClick={() => {
                  setImgShow(dataReviewDetail?.groupImage?.reviewImage3);
                  setIsShowFullImage(true); //showmodal alert cancel
                }}
              />
            )}
            {dataReviewDetail?.groupImage?.reviewImage4 && (
              <ImgReview
                src={dataReviewDetail?.groupImage?.reviewImage4}
                onClick={() => {
                  setImgShow(dataReviewDetail?.groupImage?.reviewImage4);
                  setIsShowFullImage(true); //showmodal alert cancel
                }}
              />
            )}
            {dataReviewDetail?.groupImage?.reviewVideo && (
              <DivVideo
                onClick={() => {
                  setImgShow(dataReviewDetail?.groupImage?.reviewVideo);
                  setIsShowFullImage(true); //showmodal alert cancel
                }}
              >
                <PlayCircleFilledRoundedIcon
                  sx={{ width: "32px", height: "32px" }}
                />
              </DivVideo>
            )}
          </DivImageReview>
          <DivHeader>
            <DivReview>
              <SpanCustomerReview>
                {dataReviewDetail?.comment}
              </SpanCustomerReview>
            </DivReview>
          </DivHeader>
          <DivHeader>
            <WrapperTextField>
              <TextField
                // InputProps={{
                //   startAdornment: (
                //     <InputAdornment position="start">
                //       <ChatBubbleOutlineRoundedIcon />
                //     </InputAdornment>
                //   ),
                // }}
                placeholder={`ตอบกลับ`}
                variant="outlined"
                className="TextField-without-border-radius"
                multiline={true}
                rows={4}
                sx={{
                  m: 0,
                  textAlign: "left",
                  width: "100%",
                  fontSize: "0.875rem",
                }}
                value={dataReviewDetail?.reply?.reply_text}
                onChange={(text) => {
                  setTextReply(text.target.value);
                  setDataReviewDetail({
                    ...dataReviewDetail,
                    reply: {
                      ...dataReviewDetail.reply,
                      reply_text: text.target.value,
                    },
                  });
                }}
              />
            </WrapperTextField>
          </DivHeader>
        </WrapperModalInside>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => {
              setIsVisibleConfirmReply(true); //showmodal alert save
            }}
            className="Button-New-Brand"
            style={{
              background: "#e04132",
              color: "#fff",
              borderRadius: "16px",
              margin: "8px 16px 8px auto",
              display: "flex",
              width: "84px",
              height: "42px",
            }}
          >
            บันทึก
          </Button>
          <Button
            onClick={() => {
              setIsVisibleConfirmApprove(true); //showmodal alert approve
            }}
            disabled={dataReviewDetail?.status === "approve" ? true : false}
            className="Button-New-Brand"
            style={{
              background:
                dataReviewDetail?.status === "approve" ? "#bcbcc0" : "#e04132",
              color: "#fff",
              borderRadius: "16px",
              margin: "8px auto 8px 16px",
              display: "flex",
              width: "84px",
              height: "42px",
            }}
          >
            อนุมัติ
          </Button>
        </div>
        {isVisibleConfirmApprove ? (
          <ModalConfirm
            style={{ borderRadius: "24px" }}
            title={"คุณต้องการอนุมัติรีวิวสินค้านี้ใช่หรือไม่?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirmApprove(value) : onApprove()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleConfirmReply ? (
          <ModalConfirm
            style={{ borderRadius: "24px" }}
            title={"ยืนยันการตอบกลับและการแก้ไขรีวิว?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirmReply(value) : onReply()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
        {isVisibleConfirmCancel ? (
          <ModalConfirm
            style={{ borderRadius: "24px" }}
            title={"คุณต้องการออกจากหน้านี้หรือไม่?"}
            callBack={(value) =>
              value === false ? setIsVisibleConfirmCancel(value) : closeModal()
            }
            textConfirm={`Confirm`}
            // icon={"delete"}
          />
        ) : null}
      </WrapperModal>
      {isShowFullImage ? (
        <WrapperImageFull>
          <WrapperFull>
            {conditions.some((el) => imgShow.includes(el)) === true ? (
              <div style={{ margin: "auto" }}>
                <video
                  style={{ boxShadow: "0 0 8px -1px", width: "80%" }}
                  autoPlay
                  controls
                  muted
                  loop
                  src={imgShow}
                />
              </div>
            ) : (
              <ImageFull src={imgShow} />
            )}

            <HighlightOffRoundedIcon
              onClick={() => {
                setIsShowFullImage(false); //showmodal alert cancel
              }}
              sx={{
                position: "absolute",
                top: "48px",
                right: "16px",
                cursor: "pointer",
                color: "#e04132",
              }}
            />
          </WrapperFull>
        </WrapperImageFull>
      ) : null}
      {isVisibleAlert && (
        <WrapperAlert>
          <DivAlert>
            <Alert className="MuiPaper-root-MuiAlert-root" severity={typeAlert}>
              {titleAlert}
            </Alert>
          </DivAlert>
        </WrapperAlert>
      )}
      {isLoading && <Loading />}
    </Modal>
  );
}

export default ModalReviewDetail;
